module.exports = __webpack_public_path__ + "static/media/body_img.36846eb5.jpeg";